import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Alert, AlertTitle, Box } from '@mui/material';
import { removeNotification } from '../../store/reducers/notificationSlice';

const Notification = () => {
    const dispatch = useDispatch();
    const notifications = useSelector(state => state.notification.notifications);

    const handleClose = useCallback((id) => {
        dispatch(removeNotification(id));
    }, [dispatch]);

    // Автоматическое закрытие уведомлений
    useEffect(() => {
        const timers = notifications
            .filter(notification => notification.autoHideDuration && notification.autoHideDuration > 0)
            .map(notification => {
                return setTimeout(() => {
                    handleClose(notification.id);
                }, notification.autoHideDuration);
            });

        return () => {
            timers.forEach(timer => clearTimeout(timer));
        };
    }, [notifications, handleClose]);

    if (notifications.length === 0) {
        return null;
    }

    return (
        <Box
            sx={{
                position: 'fixed',
                left: '50%',
                transform: 'translateX(-50%)',
                bottom: 10,
                zIndex: 10000,
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                maxWidth: '400px',
                width: 'calc(100% - 40px)',
                pointerEvents: 'none',
                alignItems: 'center',
            }}
        >
            {notifications.map((notification) => (
                <Box
                    key={notification.id}
                    sx={{
                        width: '100%',
                        pointerEvents: 'auto',
                        transition: 'all 0.3s ease-out',
                        opacity: 0.9,
                        p: 0,
                    }}
                >
                    <Alert
                        onClose={() => handleClose(notification.id)}
                        severity={notification.severity}
                        variant="filled"
                        sx={{ 
                            width: '100%',
                            lineHeight: '1.2',
                            fontSize: { xs: '0.8rem', sm: '0.9rem' },
                            py: 0,
                            px: 1,
                         }}
                    >
                        {notification.title && (
                            <AlertTitle>{notification.title}</AlertTitle>
                        )}
                        {notification.message}
                    </Alert>
                </Box>
            ))}
        </Box>
    );
};

export default Notification;

